export const formatDateLabel = (dateTimestamp: number) => {
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    const date = new Date(dateTimestamp);
    const now = new Date();

    // Check if it's today
    if (date.toDateString() === now.toDateString()) {
        return 'Today';
    }

    // Check if it's tomorrow
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    if (date.toDateString() === tomorrow.toDateString()) {
        return 'Tomorrow';
    }

    // For other dates, use standard formatting
    return date.toLocaleDateString(locale, {
        weekday: 'short',
    });
};